<template>
  <Modal v-model="modifyStockQuantityModal" :title="$t('key1006840')" width="1000" :transfer="false"
    :mask-closable="false" @on-visible-change="modifyStockQuantityChange">
    <div class="table_box">
      <Table
        highlight-row
        border
        max-height="500"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData">
      </Table>
    </div>
    <template #footer>
      <div style="text-align: right;">
        <Button @click="modifyStockQuantityModal = false">{{ $t('key1000112') }}</Button>
        <Button type="primary" @click="modifyStockQuantityBtn" :disabled="tableData.length <=0">{{ $t('key1000111') }}</Button>
      </div>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from "@/components/mixin/common_mixin";
import api from "@/api";
import {commonCopyContent, setConfigCharacters} from "@/utils/common";

export default {
  name: "modifyStockQuantityModal",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      modifyStockQuantityModal: false,
      tableColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000239'),
          key: 'skuInfo',
          align: 'left',
          minWidth: 350,
          render(h, params) {
            if (params.row._productInfo) {
              let supplierSku = params.row._productInfo.sku || ''; // 供应商sku
              let ymsSku = params.row._productInfo.ymsSku || ''; // 云卖sku
              let productGoodsSpecifications = params.row._productInfo.productGoodsSpecifications || [];
              let spec = productGoodsSpecifications.map(i => i.name + '：' + i.value).join('、');
              let skuImgPath = params.row._productInfo.primaryImage;
              let spuImgPath = params.row._productInfo._spuInfo.primaryImage;
              let imgPath = skuImgPath ? skuImgPath : spuImgPath;
              let list = [
                v.tableImg(h, params, null, imgPath),
                h('div', {
                  class: 'text-align-left pl10'
                }, [
                  h('Alink', {
                    props: {
                      linkName: params.row._productInfo._spuInfo.name,
                      textAlign: 'left',
                      className: 'mb5',
                      AlinkShow: true
                    },
                    on: {
                      AlinkBtn: () => {
                        const {href} = v.$router.resolve({
                          path: '/productDetails',
                          query: {
                            type: 'look',
                            productId: params.row.productGoodsId
                          }
                        });
                        window.open(href, '_blank');
                      }
                    }
                  }),
                  h('p', {class: 'flex align-items-center mb5'}, [
                    h('span', {style: {color: '#000'}}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003976') + supplierSku),
                    supplierSku ? h('Icon', {
                      props: {
                        type: 'ios-copy-outline',
                        size: 18,
                        color: '#01a6ee'
                      },
                      style: {
                        marginLeft: '10px',
                        cursor: 'pointer'
                      },
                      attrs: {
                        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000003')
                      },
                      on: {
                        click: () => {
                          commonCopyContent(supplierSku, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000002'));
                        }
                      }
                    }) : ''
                  ]),
                  h('p', {class: 'flex align-items-center mb5'}, [
                    h('span', {style: {color: '#000'}}, `${setConfigCharacters(false)}SKU：` + ymsSku),
                    ymsSku ? h('Icon', {
                      props: {
                        type: 'ios-copy-outline',
                        size: 18,
                        color: '#01a6ee'
                      },
                      style: {
                        marginLeft: '10px',
                        cursor: 'pointer'
                      },
                      attrs: {
                        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000003')
                      },
                      on: {
                        click: () => {
                          commonCopyContent(ymsSku, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000002'));
                        }
                      }
                    }) : ''
                  ]),
                  h('div', {class: 'flex align-items-center'}, [
                    h('p', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000240')),
                    h('p', {
                      style: {
                        flex: 1
                      },
                      class: 'color-green'
                    }, spec),
                  ])
                ])
              ];
              return h('div', {
                class: 'flex ptb10',
              }, list);
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001342'),
          key: 'shippingWarehouse',
          minWidth: 200,
          align: 'center',
          render(h, params) {
            return h('span', v.warehouseName);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004428'),
          minWidth: 100,
          key: 'quantity',
          align: 'left',
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006836'),
          minWidth: 190,
          key: 'updateQuantity',
          align: 'left',
          render: (h, params) => {
            return h('div', [
              h('InputNumber', {
                props: {
                  min: 0,
                  max: 99999999,
                  value: params.row.updateQuantity,
                  formatter: (value) => parseInt(value),
                  placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006837')
                },
                style: {
                  width: '160px'
                },
                on: {
                  input: value => {
                    v.$set(v.tableData[params.index], 'updateQuantity', value);
                  }
                }
              })
            ]);
          }
        },
      ],
      tableData: [],
      packageId: null,
      packageCode: null,
      warehouseName: null,
    };
  },
  methods: {
    // 初始化数据
    getModifyStockData(row) {
      let {packageCode, packageId, warehouseName} = row;
      this.packageCode = packageCode;
      this.packageId = packageId;
      this.warehouseName = warehouseName;
      this.axios.get(api.get_packageInfo_queryAllPackageGoodsById + packageId,
        {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000514')}).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas || [];
          if (data.length > 0) {
            let productGoodsIds = [];
            data.map((item) => {
              item.updateQuantity = null;
              productGoodsIds.push(item.productGoodsId);
            });
            if (productGoodsIds.length > 0) {
              (async () => {
                this.tableData = await this.getProductInfoByIds(productGoodsIds, data,
                  false, false, false, api.post_productInfo_queryByProductGoodsIds, 'supplier');
              })();
            } else {
              this.tableData = data;
            }
          }
          this.tableData = data;
        }
      });
      this.modifyStockQuantityModal = true;
    },
    // 确定按钮
    modifyStockQuantityBtn() {
      let v = this;

      function isNullOrEmpty(value) {
        return value === undefined || value === '';
      }

      let query = {
        packageCode: v.packageCode,
        packageId: v.packageId,
        updatePackageGoods: []
      };
      if (v.tableData.length > 0) {
        let talg = v.tableData.every((item) => {
          return item.updateQuantity === null || item.updateQuantity === '' || item.updateQuantity === undefined;
        });
        if (talg) {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006838'));
          return false;
        } else {
          v.tableData.map((item) => {
            query.updatePackageGoods.push({
              originalQuantity: item.quantity,
              packageGoodsId: item.packageGoodsId,
              productGoodsId: item.productGoodsId,
              sku: item.sku,
              updateQuantity: item.updateQuantity
            });
          });
        }
        v.axios.put(api.put_packageInfo_upatePackageGoodsQuantity, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
          if (response.data.code === 0) {
            v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006839'));
            v.modifyStockQuantityModal = false;
            v.$emit('updateData', true);
          }
        });
      }
    },
    // 监听弹窗
    modifyStockQuantityChange(value) {
      if (!value) {
        this.tableData = [];
        this.packageId = null;
        this.packageCode = null;
      }
    }
  }
};
</script>

<style scoped>

</style>